// Test IDs for the Trails Map + Adaptive Filter + Wishlist features.
export const TRAILS = {
  page: 'trails-page',
  map: 'trails-map',
  trailCard: (slug) => `trail-card-${slug}`,
  trailMarker: (slug) => `trail-marker-${slug}`,
  trailPopup: (slug) => `trail-popup-${slug}`,
  filterAdaptive: 'trails-filter-adaptive',
  filterAll: 'trails-filter-all',
  navTrails: 'nav-trails',
};

export const ADAPTIVE = {
  section: 'adaptive-filter',
  chip: (key) => `adaptive-chip-${key}`,
  why: 'adaptive-why',
};

export const WISHLIST = {
  heart: (slug) => `wishlist-heart-${slug}`,
  navCount: 'wishlist-nav-count',
  panel: 'wishlist-panel',
  panelClose: 'wishlist-panel-close',
  panelItem: (slug) => `wishlist-panel-item-${slug}`,
  panelRemove: (slug) => `wishlist-panel-remove-${slug}`,
  panelEmpty: 'wishlist-panel-empty',
};
